import { NamedContainer as Component } from './named-container';

/**
 * createWidget не нужен, потому что лишняя обертка для пустой функции.
 */
export const NamedContainer = Component;
